import React, { FC, ReactNode } from 'react';

export const NoLeaderboardData: FC<{
  title: ReactNode;
  description: ReactNode;
}> = ({ title, description }) => {
  return (
    <div className="flex h-[500px] flex-col items-center justify-center pl-5 pr-5">
      <img
        src="/assets/icons/empty-leaderbord.svg"
        alt="emptyLeaderboard"
        className="mb-5"
      />
      <div className="text-text300 max-w-[70%] text-center text-base font-medium">
        {title}
      </div>
      <span className="text-text600 max-w-[70%] text-center">
        {description}
      </span>
    </div>
  );
};
